<template>
  <div class="accordion mb-5">
    <div class="accordion-item" v-for="(content, i) in contents" :key="content.id" :class="{ 'accordion-active': content.active }">
      <div class="accordion-header">
        <a href="#" @click.prevent="expand(i)">
          <div class="accordion-header-div col-3">{{ content.title.rendered }}</div>
          <div class="accordion-header-div col-2">{{ content.acf.phone_number }}</div>
          <div class="accordion-header-div col-5"><span class="text-ellipsis">{{ content.acf.address }}</span></div>
          <div class="accordion-header-div col-2 text-center">
            <button class="btn light small" role="button" target="_blank" @click.prevent="openMap(content.acf.google_maps_link)" v-if="content.acf.google_maps_link">{{ $t('message.direction') }}</button>
          </div>
        </a>
      </div>
      <div class="accordion-body" v-bind:ref="'accordion-body-' + i">
        <div class="accordion-content">
          <div class="row">
            <div class="col-4" v-if="!!content._embedded['wp:featuredmedia']">
              <img :src="content._embedded['wp:featuredmedia'][0].source_url" :alt="content._embedded['wp:featuredmedia'][0].alt_text" class="img-fluid d-block">
            </div>
            <div class="col">
              <div class="row" v-if="content.acf.address">
                <div class="col-2"><p>{{ $t('message.address') }}</p></div>
                <div class="col-10"><p v-html="content.acf.address"></p></div>
              </div>
              <div class="row" v-if="content.acf.barber_name">
                <div class="col-2"><p>{{ $t('message.barbername') }}</p></div>
                <div class="col-10"><p v-html="content.acf.barber_name"></p></div>
              </div>
              <template v-if="content.acf.sns">
                <div class="row" v-for="(sns, key) in content.acf.sns" :key="key">
                  <div class="col-2"><p>{{ sns.social_network }}</p></div>
                  <div class="col-10">
                    <p v-if="sns.social_network_link">
                      <a :href="sns.social_network_link" target="_blank">{{ sns.social_network_username }}</a>
                    </p>
                    <p v-else>{{ sns.social_network_username }}</p>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap, TweenLite, Power2 } from 'gsap'
import { CSSPlugin } from 'gsap/CSSPlugin'
gsap.registerPlugin(CSSPlugin)

export default {
  name: 'Accordion',
  props: {
    contents: {
      type: [Array, Object],
      default: null
    }
  },
  methods: {
    expand (i) {
      const el = this.$refs['accordion-body-' + i][0]
      if (this.contents[i].active === false) {
        this.contents[i].active = true

        TweenLite.to(el, 1, {
          height: el.scrollHeight,
          ease: Power2.inOut,
          duration: 1
        })
      } else {
        this.contents[i].active = false

        TweenLite.to(el, 0.5, {
          height: 0,
          ease: Power2.inOut,
          duration: 1
        })
      }
    },
    openMap (location) {
      window.open(location, '_blank')
    },
    getMapUrl (location) {
      const { address, lat, lng } = location
      let destination
      if (address) {
        destination = address
      } else {
        destination = `${lat},${lng}`
      }
      return `https://www.google.com/maps/dir/?api=1&destination=${destination}`
    }
  }
}
</script>

<style lang="scss" scoped>
$base-time: 200ms;
$app-padding: 2rem;

$accordion-header-font-size: 1.2rem;
$accordion-header-height: 2rem;
$accordion-header-padding: 1rem 0 1rem 0;
$accordion-header-border-radius: 0;
$accordion-header-transition: background-color $base-time ease-in-out;

$accordion-header-hover-background-color: #f7f7f7;

$accordion-caret-color: #000000;
$accordion-caret-background-image: linear-gradient(to top right, transparent 50%, $accordion-caret-color 50%);
$accordion-caret-width: 0.5rem;
$accordion-caret-height: 0.5rem;
$accordion-caret-transform: rotate(-45deg);
$accordion-caret-transforming: rotate(45deg);
$accordion-caret-active-transform: rotate(135deg);

$accordion-body-content-padding: 1rem;

.accordion {
  margin-left: -15px;
  margin-right: -15px;
  overflow: auto;
}

.accordion-item {
  &.accoordion-active {
    .accordion-caret {
      animation: accordion-is-active $base-time linear forwards;
    }
  }
}

.accordion-header {
  display: block;
  position: relative;
  a:not(.btn) {
    border-radius: $accordion-header-border-radius;
    box-sizing: border-box;
    color: inherit;
    display: flex;
    flex: 1;
    height: 100%;
    justify-content: space-between;
    text-decoration: none !important;
    &:not(.accordion-active):hover {
      background-color: $accordion-header-hover-background-color;
    }
  }
}

.accordion-header-div {
  // padding: $accordion-header-padding;
  padding-bottom: 1rem;
  padding-top: 1rem;
  // &:last-child {
  //   padding-left: 0;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  // }
}

.accordion-caret {
  background-image: $accordion-caret-background-image;
  width: $accordion-caret-width;
  height: $accordion-caret-height;
  transform: $accordion-caret-transform;
  animation: accordion-is-inactive $base-time linear forwards;
}

.accordion-body {
  background-color: $accordion-header-hover-background-color;
  height: 0;
  overflow: hidden;
}

.accordion-content {
  padding: $accordion-body-content-padding;
}

@keyframes accordion-is-inactive {
  0% {
    transform: $accordion-caret-transform;
  }
  50% {
    transform: $accordion-caret-transforming;
  }
  100% {
    transform: $accordion-caret-active-transform;
  }
}

@keyframes accordion-is-active {
  0% {
    transform: $accordion-caret-active-transform;
  }
  50% {
    transform: $accordion-caret-transforming;
  }
  100% {
    transform: $accordion-caret-transform;
  }
}
</style>
